import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import MessageBubble from "./MessageBubble";
import "../../styles/Component/Chat/ConversationThread.css";

const ConversationThread = ({ messages }) => {
  const threadEndRef = useRef(null);

  useEffect(() => {
    if (threadEndRef.current) {
      threadEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages]);

  return (
    <div className="conversation-thread">
      {messages && messages.length > 0 ? (
        messages.map((msg, index) => (
          <MessageBubble key={msg._id || index} message={msg} />
        ))
      ) : (
        <div className="no-messages">
          <p className="text-muted text-center">No messages yet</p>
        </div>
      )}
      <div ref={threadEndRef} />
    </div>
  );
};

ConversationThread.propTypes = {
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      body: PropTypes.string.isRequired,
      direction: PropTypes.string.isRequired,
      sender: PropTypes.string,
      createdAt: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default ConversationThread;
